import slugify from 'slugify'

export const networkSlug = (networkName: string): string => {
  return `hm-${slugify(networkName, {
    lower: true,
    strict: true,
  })}`
}
